import React from 'react'


const MyItemLi = ({data}) => {
  return (
    <li className={data.noLG?'d-lg-none':''}>
    <a
      style={{ color: "inherit", textDecoration: "none" }}
      className="lomasnuevohover"
      href={`${data.url}`}
    >
      {data.text}
    </a>
  </li>
  )
}

export default MyItemLi